<template>
  <div>
    <div class="bg-card">
      <div v-if="paymentStatus === 'success'">
        <b-alert
          show
          variant="success"
          class="p-5"
        >
          <div>
            {{ $t('pages.payment-callback.success') }}
          </div>
          <div class="mt-2">
            {{ $t('pages.payment-callback.thank-you') }}
          </div>
        </b-alert>
      </div>
      <div v-if="paymentStatus === 'fail'">
        <b-alert
          show
          variant="danger"
          class="p-5"
        >
          <div>
            {{ $t('pages.payment-callback.fail') }}
          </div>
          <div class="mt-2">
            {{ $t('pages.payment-callback.thank-you') }}
          </div>
        </b-alert>
      </div>
      <b-button
        variant="success"
        size="sm"
        @click="$router.push({ name: 'my-offers' })"
      >
        {{ $t('pages.payment-callback.continue', 'Continue...') }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        paymentStatus() {
            return this.$route.query.status;
        }
    }
}
</script>